// extracted by mini-css-extract-plugin
export default {"popup":"ConfirmationPopup__popup--lpd","inner":"ConfirmationPopup__inner--mo-","content":"ConfirmationPopup__content--84_","btn":"ConfirmationPopup__btn--1vz"};